import gql from 'graphql-tag';

export default fields => gql`
mutation ($id: String!) {
    deleteAdvertiser (input: { id: $id }) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Advertisers/DeleteMutation.js